export default __webpack_public_path__ + "static/media/location-active.4c124526.svg";